export const Bio = {
  name: "Swayam Prakash Sahu",
  roles: [
    "AI ML Engineer",
    "Full Stack Developer",
    "Problem Solver",
    //"UI/UX Designer",
  ],
  description:
    "I am a driven and adaptable professional, constantly seeking new challenges to expand my horizons. With an insatiable curiosity and a commitment to excellence, I strive to deliver outstanding results in every endeavor. My positive attitude, coupled with a growth-oriented mindset, empowers me to make meaningful contributions and achieve remarkable success.",
  github: "https://github.com/SwayamSahu",
  resume:
    "https://drive.google.com/file/d/14ipDGD3JDNSbY68ZXKewOlE43VZ15VOa/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/swayamps/",
  twitter: "https://x.com/swayamps",
  // insta: "https://www.instagram.com/swayamsahu/",
  
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "TypeScript",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/Typescript.png?alt=media&token=18dcf7e8-b0b9-4af4-89ea-94e8f01465fe",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAY1BMVEWCgoL////l5eXk5OTm5ubu7u74+Pj19fXx8fH7+/vr6+t+fn52dnZ7e3t8fHzz8/OGhoaTk5Pa2tq3t7e7u7utra3Q0NCZmZnFxcWkpKSMjIzKysqpqanX19e/v7+dnZ1ra2tH/Sn9AAASPElEQVR4nOVdbZuyKhBWwTcErcxqa7fO//+VB9RKGF6tdvWc+bLPNY+m48DMzc0AURzHWYKTjP9FOEn5nzTBaKJNPLW5UYtxQozawqYtH1o8V4ui/4eFKEG9hcn4fgmaqU2S0ZaHNndpi0Fbjlr8Ni0atVGWZXmapjn/y/8U/E/B//6etnmnttFoI/4BemcgxUVBWuLS8iaES/6XENLwPw1vSpPPngzXPj67TYtDtIhrI6ztZm/pkuKZDbcpLgt0uV73+7b74tJ1bdterztUZDgl5Se6JJpoP+ZD/uNNnKNTdztHlFJWV7LUjCuj8609oIx/hfRzPvxI3yqanBzaIzeNGxbZpKq4pdG2PeBcdKKXepyhH747lgotut4iyuymKYYyGt1O6aRpvi+WvrXzYZKSXbehDscZrKxp1F1wms7sfNZ8iAa/oLGbIeSjJRrt9RjmO+hLtj31HkDD+6GhS6Kxm3losaKNAs0yG9uQ042+Yt1dano8lS+ahT6QLUjH2BvMG42sOxKTt2WLV8MLwqT42b7FfU+p6PYkUunrQSd6PUU0pK3e576nsKgl8euJQ84W4ck/IWj/UmyxScW+EQlO/gi9M1vkqPuYfYONXfGWbDHbh+1H7Rts3AdCNUX7Qj/M8lNUf9g+IXV0KssX+uH8WIo2n4gvOmFnFAjVprF0bj7Mvukv2SeEfudkbj6cBdUScnhz/nMJ745kHoCbh0uz2286cBB2K3NvqDbFpeHZAse/7cBBKnpKfZvmS1wbSY6/78BB2FGid/wAXPAYvznMGvy9R6rqEH+Ya0ua6185cBDaEm1eQO/i2vDxt3KgSdgRuUmA2Vwb2W3+roXepdqgIAAX0g/zw187cBB2yD/DtaXt33bBp/DO6IBqs0ZP6dcyPCiEfZXeAM4b0xTH3xhH+Aq72aHaFNP4RRqcnP8+xkylOqO3ZguMFhBEZRlCqgmqhXJtJdr8tUE6yd/GtZVkaQ4cJS0n75tqE0fqw7VhtFADo2j3Fq4NL7OJ9rJ5C9eWLNdAHlHdAM7ZD/OFpQlZqm2hQrU8kGtLj0s2kJt4dAE4Rz5Mv5aEZHRS6wCcP9eWt8vBoiahJzuAs0YacljKaMIm9IKtkcaWLXbL96AQtsMWAGcZHyZ4wXlCkk0410Z6Vm3hYfQp1TZWoJoX19Zc19FGhbCOhI+e8M8aosxd6CGYa8PJX790mFTBXFu8mk44SHUsIdeW27i2VWTCqdALCeHakmxtBnITrflQ5drIbV1ttJctCeDaVtdGhdCDPtLossUK26gQmjW+XNv3Ctsol+o7s3NtZEwcGVqnC7kTf0YriJ1ry9cCuKGc/bi203rwqCrs4sW1/fVrviKVB9fWtEtnZmxSt42La0vQetuoELZzcW2kW2emuEvVObm2dbtQpH0719bs1+1CkfaJbWyBydpdyIONNVuQdu0u5E5sCeTaSErEGJ+kxfoN5CYWI9c2ADh59PQT3EjF4roqOh+3x/OG/5u5y/oAJvT9qup1GwO6ZD+xmWvbej5sfCSj5/ZARAMfJCM/+1tlLz5lRawI8QP61Zd649Fw5TZOTFyb57PGV2VfP6X6UCGojay/A27wI2Yr9TbjrBFFyXQEnOcj15ZnTUC2p+eDzrpRdluzjdAX8dbjuTRRbjLzuVVX5gPXlitcm3+qoEdksa935Nn4Y/SiXty42w5rlXtyy8uy2JAPfYdNbLNz2CfkZHxtmqrXXpxPPqu32PzODgau7eZnIL162Ce+4tk0StmAa13tlKrxyTp1W91kru1BknrFmaqv8PCTzvCL9bd6pYP7omqn3zmuR4lubHH1iTMUxgmLXAwvAt7YEjciTXDKHK262uPHngVPH6am9CK92j7EQPO3Zo16pY2DBoni7HrPSYUGH+OTYYzvkwxhGJxrIogcpZlaoGrgdtdPUJJDrs1j0h42LrcYmh+I/uauBS51dML+nl0Os4U73fd1HUDK5HDat/vrAWW6/zZlDQoyjomHVt1ty4R3qbocjp6cLCnr4Ovj9nzf1YND8HOrAg8hX/o3ZwDy6R8LEoUPAoo2mcy1cZDjJLqrLXj3n7OCsistmNN/O/h72lcAXd+viIlibpTEtRVO+oKpjRCddW+kATzY0BUBcuhgtBHJWxKPTtj/uPgwUj5sDG3pIaDfGFdfwJRpYA5AjNRkgUppy65M+LhPgAqJa8t97phIaUbWfKiqAk/TtaqFIGOBj+DVCe+/PeXasCsbKnGhtI/M1RczLCcCTTDeyxeCRLH3H/7s5P3asGNJk9pnXNQDxfL1hkANEYTcTtVE4dkJhdQnOVs4SbbQtkJlWGYigKgK49OpDWqi8O2EQqqWTLk20thBKZNzgE/AVj6/6TIwkJoMUoGH/Tshl2Mjc232q2Xo6zXMUrrQyQA71Qg2YcNALw0s55W5Nvv4rJZ7oRPZ9yI3sdKYW1SIkN+vVEFPQCfsfziXuDY7oqH59EmepSiKC4zVDwCVjYNKNR6XgVwuv//OteV52pgake5d/VyoRhHz0AUMpPqSOpAoQgvt6lPT2zbEUvusIZPgjHdjUbqY0UKA6HtvqXYH19RX3VAbPeRDYiWhqPQoF7ybvLrnffRHsYb3AzWNzKiAuZGnhYjYWp7Ckvh/Sya9uYUxrKV+Lr6GmihCO6GQ82jhEEttV9bSwDcgolVS80vNN4KBVKkmiqBMeJfp2MIYy4XIDSZkklhOo5YLmYPg8oej0x8tJ1xbYbNQ7k4hdZkydLPdCQdSU5lXhkaLwYeEkKK0/sRRelpISZgchK3eB4ThRLJ5FT4MpYSk5RBLbfMGlZyYgibgpHhhnX6t5O8oycyS8/7pYyzFV8tXklF3wzb+EkndyxJqxGO0RJ6Ques+6v3UQttEjmsizVcsnK8QMJAaZXYtaHWNH1xbaesicC5srji6MJyR6r/L7OKJ6ppz2/IhllotfJeBrioBzeRwPLsTit/bk2c+tI3w32ehk87TcK0vLL7iFj65Nhvwrt9mobMcSdMVZ9snIBV5cG3E9nX13WOOOOGQpp3aA7D718ZY+ksWWgeh/TvpbpptYj+svVtoA1RggDpbXPUIeug2O9TcLRR8VGHz4fv6ocNCOKXYiyONWiz8ikWx3sDT2CIN0z53loX2dzU1lrkp/x5p+mxhs1DOFqL8dqZgeywFjNRDunkZo+rSJ9dmzYfSAJz8Q2eL3UDLDLov96VYyDP+nWtrbBYyaQrihehtfx0wSfPyQ6s2e3Bt1vYjD/I+ZqHFQHNdjv0nReTyGVvINI2V75gvgP5VTJyz4vM+thgstI2AZTrzIxaqiaJQYcacEUY9+rCPpdZamvkshreoiWILaq9mpAy2688eGCy03i8nRJ/asFBRh6AnBkF4+D4yFBFPrk1OVB9YNaTSv31BLcj/wSmDNhOuzTq55k1dzxSQKHpbAIXqUUgsC82eXBvC1jeQwkBQtbuXqIliDHugnQanjOnMTGptAnKDmWuISdRCnUfGBe00MGWcpZkZ+9yTVA0V0hHZVAyXqCOKs/F/Aj/ubfRhURRNXlpBsdwRDTVc2hsvu4noiSjVU5MpCrVkJSxlVG3JbbtzbaaSnvFamVzwX1gj5xntJWqikLu56sSQGRp2kOra7F9HflP/SWDpy2hDFFMLSqSAUIN6z4BlS2Ief1LXZq/FkJup92PkGKJjaUCiUJwEeI2AlMGjx7OuLcHEfrUM3HzHFzK41IEhlSGBfVx1YsCeJESU85bJ3UI7GFN6ix//JY9pdRVboKITJK0KtFPvMoIjCalrUx/ks5uiMl+mwUKgm2mwJ+TfPA2c1rWVOQc3jtpEqtQS+MyrO9wDE4U+D6kW+i3t4TFMrCEts0ddmyPLgfIz5wkClVw0rQnAYFJLOzCD8dQvZYgZdmkNqatGGGRf05qm0b6NUhUO469viTpsp36xPFbWkDYu0AdQ4o/lMCtQ6g1dCBKFOSWrT8492ulQ5/3g2ji4yVyTCrCyPm4N/CCLADMIG6Baom4mD2A79UgZ9bXhiE3Y9lhR4kxymqmvvGPAkRWN4Iw83C8Flv5b1j2B9Q3ulEF3GKwKchMwunXNh+/oeRJuzejmW7O+FDZA4BcrbAT+dqeMTQbXkDpHRZpFM4Mnd5e9OMq42192aoFaLw0MIaBX258M5hVdA5yqfZwNxWMp7tcfYjc9UQetrnwKbB2gxTs+L2ynjtlvdhlOXcaTNaQYu9MMm2Ui3BAcLIJzDvzgMjA75mDJzDWkzDa7oJccLs2AcxTOB8Nb7CsTpmtIB66tLEjqnITmUp/1iwyNomsZteoQD2IEVNlaU0Z9SnNu1IRrG3Yc8Bsx+KzFf4huFAJ+wWtIDdvptyW/GHYc8FuPT8EKCaPkuhPaYAL3eqxm+s2Y3/r1+LodeDz3VKgA9WCQkxbzgEThSd7BdmpMGYKTePqw59rynGOcwrsmgG08ljxfIu0HA4nCm/aB7dSUMmg+GDXl2ob92vypUFZdtcn9LunecAgySBT+82bem6KIzbAM+7WFMPbifHBDvSQ+Gc+whoWyATuJwnaqJ9Aowsb92sL2GKppddwfyMSZOTmITYYsrV19x6DFTGApcqzdXm4bg/3a7uePkfBtL8UidVZtztvteRP1/7b65HzcyhL2tI1y91aHUtipX7rN/RhPuLZxvzYHqbgS+d/t11aWgmsjOf/L/6Tr33OPCahWlg23JisnXNu42/VaN0l+ipjPtZ6N8B/Z+9JyNgJZuRN7jk3esXzk2sY/Ta6hHNYkrCgGa5pC5dri+9kItvUzi5f66nM2wpqbaeV1NsLa9/NWz0Z4cG09yBFbZJTzClaXIBsyQjWMn7EUno1gX424ZKE/WDkbQbPbNcK8wfov116UiLMR7hYihWsry4L/fQA4n920Figsf0C1Jwwt5WwxJn+yosOsnsLGrQS9ziFNV3nOTBpyDumHyrk/KfTR+RQfTri2CYDLV5cU2amUrNBzbRN3ktWd2dXEmlPJrOeQ/vU7B0oSfA4pXtWZT/ez80znkHJbe65NAnAzquP/TEQZhQTVjFybfJjHarpiP/8uQTWQLTDSWJgs+bxqSTYAqk0tlLk2CcClazlLFqUqVDNzbUryX0W0EdMZKlTzOYc0WdWZzrZTq60+TMnX0k1kw7ncifkcUhnkKACuycuFY/DqFuugmpVrUwEcLIdZkFRnPVTzPZd7mHNbcs7YTDpfEnIOqQzg/toMi5igmoVrGwGcpHXVD/+dZCXWQjVs59pgg13qIUm5Eaq5uDbVwnKJDbXiBhqhmotrgwAOb5bmxuqMSzNUc3FtcvIf4s/CkoZIExaoFpYtBm0xa3PGT0l9hHnBmi2sPrwDuNtyABy7OaCamWtrLAAu3i9lpEH3LqjmwbWNWtmd12WYKBbFOaCaF9em0ZKfJfTFeufufD5cm1aLkfGUqt8Sdu7fzAHVDFybB4CLy++/bam0Hd5MhmpYhWoTrSVbID0D9/5tIwKk3yzHA6r5cW0GLbEci/dhYVuEVVCmh2qeXJsEiCba8o/SBt0X/Ttk2jcL5dqQTUt2f+BGdu6PzEy8oJo316YHcFxL9HX4n5OKtinW5AWPbGHn2sza/PabTZXeUqIHZU5tZIRqDm2TGZYbfEBYdMkAiNRDS6jVcW2q4wzaIr5algK/Typ2JcQIyt7BtVm0PP9/2saKdplf53uBazNoxe/ku9tHbazokUwDqATK9FoL1yaSKYRqd21u0hZfH7OR+6+IG/AOE1DmAeAgE2UBcIlWS1BHPxFzatohXQbwgWqhXJtdy7Njetm82ZEV3Vwx8QBl7+LaTADufm0c777e6EhGv3ZxagNlZqimal+MNA9tgsv4YFzQFSQ8uhxSgsNjiiHSvJQtplrx62i/pS/lyKqm22s2Ly+8zLX5aHmXJGKXhXqOlVXFou6EyDCE9wVl7+HaQrR5nmXodItYkJUVo9HtuhNbbweCMqfWiLyDAJxGuzt9b/stM5ztkhu37U48WDV4Bih7L9cW0iV5b2jiHJ262zmilD12B6meu4RQGp2P3QWJ0Jc+u87zF5LZnW821+YVViVtI5Ja2aDLdb/ft93X7fbVdW3b7q871GT8P6VRrQcoCw6req5tJoC7ayGk6ktXSJ/BY5KSHgoRy7VWUBYG4KxMVBCAy21aArVyI9RrZ0O1l7g2K4BLVG0+aIlR+yoo+wjX9prWC369rn0AuE9HmlTu+3rtRyPNv+c/cIe0nzmlAAAAAElFTkSuQmCC",
      },
      {
        name: "Graph Ql",
        image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Flask",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Flask_logo.svg/1280px-Flask_logo.svg.png",
      },
      // {
      //   name: "Django",
      //   image:
      //     "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlFFyY16N5NRhzoG24RqB7x8Ok2t8Bdgs-tuMsOBXS2Q&s",
      // },
      {
        name: "FastAPI",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/fastapi.png?alt=media&token=fb493702-1fd1-4080-9411-19b9a32ae162",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  // {
  //   title: "DevOps",
  //   skills: [
  //     {
  //       name: "AWS",
  //       image:
  //         "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
  //     },
  //     {
  //       name: "Google Cloud",
  //       image:
  //         "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/Google-Cloud-Platform-GCP-logo.png?alt=media&token=3b281f5d-e0f6-4c15-ba03-4c1dae9df53d",
  //     },
  //     {
  //       name: "Docker",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
  //     },
  //     {
  //       name: "Jenkins",
  //       image:
  //         "https://toppng.com/uploads/preview/jenkins-logo-11609365847mufysaivph.png",
  //     },
  //     {
  //       name: "Nginx",
  //       image: "https://download.logo.wine/logo/Nginx/Nginx-Logo.wine.png",
  //     },
  //     {
  //       name: "Grafana",
  //       image:
  //         "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/Grafana_logo.svg/1200px-Grafana_logo.svg.png",
  //     },
  //     {
  //       name: "Kubernetes",
  //       image:
  //         "https://upload.wikimedia.org/wikipedia/commons/0/00/Kubernetes_%28container_engine%29.png",
  //     },
  //     {
  //       name: "Prometheus",
  //       image:
  //         "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Prometheus_software_logo.svg/1200px-Prometheus_software_logo.svg.png",
  //     },
  //     {
  //       name: "Terraform",
  //       image:
  //         "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/terraform.png?alt=media&token=b022b684-33c2-47a7-99b9-7240dfe2f074",
  //     },
  //   ],
  // },
  // {
 {
  title: "AI / LLM Orchestration",
  skills: [
    {
      name: "LangChain",
      image:
        "https://avatars.githubusercontent.com/u/126733545?s=200&v=4",
    },
    {
      name: "LangGraph",
      image:
        "https://avatars.githubusercontent.com/u/139895814?s=200&v=4",
    },
    {
      name: "CrewAI",
      image:
        "https://avatars.githubusercontent.com/u/159934755?s=200&v=4",
    },
    {
      name: "LiveKit",
      image:
        "https://avatars.githubusercontent.com/u/68504095?s=200&v=4",
    },
    {
      name: "Hugging Face",
      image:
        "https://huggingface.co/front/assets/huggingface_logo-noborder.svg",
    },
    {
      name: "Chroma",
      image:
        "https://avatars.githubusercontent.com/u/112159584?s=200&v=4",
    },
    {
      name: "FAISS",
      image:
        "https://avatars.githubusercontent.com/u/27659521?s=200&v=4",
    },
    {
      name: "Pinecone",
      image:
        "https://avatars.githubusercontent.com/u/54333248?s=200&v=4",
    },
  ],
},

  {
    title: "Machine Learning",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Tensorflow",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/tensorflow.jpg?alt=media&token=cdba1c19-8277-4c71-9c83-7a01ec5ca8f9",
      },
      {
        name: "Keras",
        image:
          "https://miro.medium.com/v2/resize:fit:600/1*DKu_54iqz6C-p6ndo7rO3g.png",
      },
      {
        name: "Jupyter",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1767px-Jupyter_logo.svg.png",
      },
      {
        name: "Google Colab",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/googlecolab.png?alt=media&token=1c65b662-301c-47ab-8478-764b32174751",
      },
      {
        name: "Scikit Learn",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Scikit_learn_logo_small.svg/2560px-Scikit_learn_logo_small.svg.png",
      },
      {
        name: "Pandas",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/pandas.png?alt=media&token=db09f3e4-1500-4028-ad60-6caf2899d955",
      },
      {
        name: "Matplotlib",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/matplotlibLogo.png?alt=media&token=ccc07f46-fc74-4c79-b6bc-aca6d2b5a89a",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "AWS",
        image:
           "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Angular Js",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/Angular.jpg?alt=media&token=abd2490c-f6a5-4e5e-8d69-1855b266f25a",
      },
      {
        name: "Postman",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/postman.png?alt=media&token=586de878-a01d-4732-bd2f-bde604a89f58",
      },
      // {
      //   name: "LangChain",
      //   image:
      //     "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/LangChain.png?alt=media&token=c1ef0649-c3d4-490b-98ba-3d2c4bbc5de2",
      // },
      // {
      //   name: "FastAPI",
      //   image:
      //     "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/fastapi.png?alt=media&token=fb493702-1fd1-4080-9411-19b9a32ae162",
      // },
      {
        name: "Prisma",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/Prisma.jpg?alt=media&token=f3cda4de-9b68-4967-b031-f4685d486663",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/gyansys.png?alt=media&token=2022b71f-5410-41fe-aefd-60fae7cf030e",
    role: "Software Engineer AI ML",
    company: "GyanSys Inc",
    date: "Feb 2024 - Present",
    desc: "Designed scalable, secure, and versioned RESTful APIs powering AI-driven applications and enterprise systems, optimizing performance to reduce response times by 40–50%. Developed RAG-based LLM classifiers with semantic retrieval (ChromaDB + LLaMA), achieving 93% accuracy with sub-200ms latency.Architected multimodal pipelines integrating YOLOv8, Whisper, BART, and Mistral for structured meeting insights with 94% detection accuracy. Built OCR-based PDF data extraction systems and scalable full-stack platforms serving 1000+ users with secure JWT authentication and RBAC. Contributed to reusable component architecture by consolidating 40,000+ duplicate code files into efficient shared modules, improving maintainability and scalability.Created and maintained scalable, secure, and well-documented RESTful APIs, implemented versioning and ensured backward compatibility. Integrated APIs with front-end and backend services, collaborating with developers, optimized performance and resolved issues, decreasing response time by 40%.",
    skills: [
  "Python",
  "Machine Learning & Deep Learning",
  "LLMs (OpenAI, Mistral, LLaMA)",
  "LangChain",
  "LangGraph",
  "RAG (Retrieval-Augmented Generation)",
  "Whisper (Speech-to-Text)",
  "YOLOv8",
  "PyTorch",
  "OpenCV",
  "OCR (Tesseract, PaddleOCR, EasyOCR)",
  "ReactJS",
  "Redux",
  "NodeJs",
  "ExpressJs",
  "RESTful APIs",
  "JWT & RBAC",
  "JavaScript",
  "TypeScript",
  "HTML",
  "CSS / Tailwind CSS / SASS",
  "SQL",
  "ChromaDB",
  "Pandas",
  "NumPy",
  "Git",
  "Pytest"
],

    doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Screenshot%20from%202024-01-25%2022-38-31.png?alt=media&token=2785903f-1a4e-41f5-afd2-6adcfe56d058",
  },
  // {
  //   id: 1,
  //   img: "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/gyansys.png?alt=media&token=2022b71f-5410-41fe-aefd-60fae7cf030e",
  //   role: "Software Engineer Trainee",
  //   company: "GyanSys",
  //   date: "Feb 2024 - June 2024",
  //   desc: "Completed intensive training in HTML, CSS, JavaScript, TypeScript, React, Angular, SQL, .NET, and unit testing methodologies Developed a Full Stack Blog website using React.js, .NET Web API & SQL database Key features: Modal Implementation, Form Handling & Validation, API Integration, Error Handling, Dynamic Data Fetching, State Management, Routing Parameters & Conditional Rendering Created a robust Full Stack Blog platform with Angular, .NET Web API, and SQL database Key Features: User subscriptions for blog updates, Categorized blog content, Authentication and authorization with JWT tokens, Role-based access control Employee Directory Application using .NET MVC framework and SQL db. Utilized C#, HTML, CSS & Js Key features: Secure user authentication, Detailed employee profiles, Robust search/filter options, Role-based access controls for data security and privacy",
  //   skills: [
  //     "React",
  //     "Angular",
  //     "ASP.NET Core",
  //     "C#",
  //     "JavaScript",
  //     "TypeScript",
  //     "POSTMAN",
  //     "SQL",
  //     "Node Js",
  //     "Express Js",
  //   ],
  //   doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1696514649120.jpeg?alt=media&token=e7f6757b-edfa-4138-a692-d6709eeef3e2",
  // },
  {
    id: 2,
    img: "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/timechainLabs.png?alt=media&token=c53329ea-673a-4d8b-80d7-bdcee0dbd29b",
    role: "Open-source Contributor",
    company: "TimeChain Labs",
    date: "June 2023 - Aug 2023",
    desc: "Increased user engagement by 25% by designing and implementing a userfriendly Neucron swipe widget, enabling seamless and intuitive transactions.",
    skills: [
      "JavaScript",
      "React",
      "Vue Js",
      "TypeScript",
      "Node Js",
      "Figma",
      "Firebase",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
  },
  {
    id: 3,
    img: "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/comviva.png?alt=media&token=4515a984-9802-44fd-aacb-b905958daf57",
    role: "AI/ML Externship",
    company: "Comviva",
    date: "May 2023 - July 2023",
    desc: "Completed a 70-hour Comviva-curated Summer Elective Course on AI and ML at Siksha 'O' Anusandhan University, with hands-on, instructor-led training and master classes by industry experts. Applied learning to a group capstone project focused on Customer Churn Prediction for a telecommunication company, culminating in a successful presentation that demonstrated practical machine learning skills.",
    skills: [
      "Pandas",
      "NumPy",
      "Matplotlib",
      "Seaborn",
      "Scikit Learn",
      "Statistics",
      "Probability",
      "Python",
      "Algorithms",
      "Google Colab/Jupyter Notebook",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1691181448873.jpeg?alt=media&token=ee85eb8f-7247-43cd-9a1d-ce9f58ea62a6",
  },
  {
    id: 4,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70",
    role: "Fullstack Developer",
    company: "GDSC ITER",
    date: "Nov 2021 - Present",
    desc: "As a developer at the Google Developers Student Club (GDSC), I had the opportunity to work on exciting projects and collaborate with talented developers who share my passion for technology. Through my involvement with GDCS, I have also had the opportunity to host and participate in numerous events, including hackathons, study jams, and workshops.",
    skills: [
      "Leadership",
      "JavaScript",
      "React Js",
      "HTML",
      "Tailwind CSS",
    ],
  },
  {
    id: 5,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
    role: "Open Source Contributor ",
    company: "GirlScript Summer of Code",
    date: "May 2023 - Present",
    desc: "Contributed to different open-source projects and learn from industry experts",
  },
];

export const education = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/university.png?alt=media&token=317003a9-fe8c-41e8-9d7c-2693e937bf91",
    school: "ITER, Siksha 'O' Anusandhan, Bhubaneswar",
    date: "June 2020 - June 2024",
    //grade: "",
    Subjects:"Calculus, Probability and Statistics, Vector Algebra, Data science and Machine Learning, Data Structures, Algorithms, Compiler Design, Theory of Computation, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks",
    desc: "I have completed my Bachelor's degree in Computer Science and Engineering from ITER, Siksha 'O' Anusandhan, Bhubaneswar. I am also a member of the Google Developers Student Club (GDSC) at ITER, where I am learning and working on exciting projects with a team of talented developers.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/school.png?alt=media&token=cddb8803-4b58-4a3e-8e79-137b7ff16430",
    school: "Kendriya Vidyalaya No. 1, Bhubaneswar",
    date: "Apr 2019 - Apr 2020",
    Subjects:"Physics, Chemistry, Mathematics, English and Computer Science",
    desc: "I have completed my high school education from Kendriya Vidyalaya No. 1, Bhubaneswar, Odisha, where I studied Science with Computer.",
    degree: "AISSCE(XII), CBSE, Science with Computer Science",
  },
  // {
  //   id: 2,
  //   img: "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/school.png?alt=media&token=cddb8803-4b58-4a3e-8e79-137b7ff16430",
  //   school: "Kendriya Vidyalaya No. 1",
  //   date: "Apr 2017 - Apr 2018",
  //   grade: "92.3%",
  //   desc: "I completed my class 10 education at Methodist School, Dankuni, where I studied Science with Computer Application.",
  //   degree: "AISSE(X), CBSE, Science with Computer",
  // },
];

export const projects = [
  {
    id: 13,
    title: "JobScraper",
    date: "Nov 2024 - Dec 2024",
    description:
      "JobScraper is a web application that allows users to search for job listings with specific keywords. The application scrapes data from various job boards and presents it in an easy-to-read format. It consists of a Flask backend for scraping job data and a React frontend for displaying the data in a user-friendly UI.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/JobScraper.png?alt=media&token=c258bafb-4ba5-49b1-8f30-f41becea3143",
    tags: [
      "Python",
      "Flask",
      "BeautifulSoup",
      "React Js",
      "JavaScript",
      "Axios",
    ],
    category: "web app",
    github: "https://github.com/SwayamSahu/JobScraper",
    webapp: "https://github.com/SwayamSahu/JobScraper",
  },
  {
    id: 14,
    title: "LinkedIn-AutoConnect-Chrome-Extension",
    date: "Oct 2024 - Nov 2024",
    description:
      "A Chrome extension to automate sending LinkedIn connection requests.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/linkedin-chrome-extension.png?alt=media&token=1506ec79-2d83-4efe-9dff-ce22126987ea",
    tags: [
      "JavaScript",
      "HTML",
      "CSS",
    ],
    category: "web app",
    github: "https://github.com/SwayamSahu/LinkedIn-AutoConnect-Chrome-Extension",
    webapp: "https://github.com/SwayamSahu/LinkedIn-AutoConnect-Chrome-Extension",
  },
  {
    id: 11,
    title: "Expense Tracker",
    date: "Jan 2024 - Dec 2023",
    description:
      "Developed a responsive expense tracker with a clean UI, handling over 1,000 transactions. Enabled real-time balance updates, with a 99.9% accuracy rate. Implemented local storage for persistent data, ensuring seamless user experience across sessions.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/Expense%20Tracker.png?alt=media&token=8ebe7cad-034a-4268-a955-d6fcbfb3ed9b",
    tags: [
      "React Js",
      "PostgressSQL",
      "Node Js",
      "Express Js",
      "Redux",
      "React Flow",
    ],
    category: "web app",
    github: "https://github.com/SwayamSahu/Expense-Tracker",
    webapp: "https://github.com/SwayamSahu/Expense-Tracker",
  },
  {
    id: 12,
    title: "Image Gallery",
    date: "Jun 2023 - Jul 2023",
    description:
      "Developed a responsive image gallery app using React.js, integrating the Pixabay API with over 500 images. Achieved 100% browser compatibility using Tailwind CSS, PostCSS, and Autoprefixer. Utilized Node.js and Git for streamlined setup and version control.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/Image%20gallery%20home%20page.png?alt=media&token=46772676-43a5-4220-8832-f8d38e98fc8b",
    tags: [
      "HTML",
      "Tailwind CSS",
      "JavaScript",
      "React Js",
      "Node Js",
      // "CI/CD",
      // "React Js",
      // "MongoDb",
      // "Node Js",
      // "Express Js",
      // "Redux",
    ],
    category: "web app",
    github: "https://github.com/SwayamSahu/React-Tailwind-CSS-Image-Gallery",
    webapp: "https://github.com/SwayamSahu/React-Tailwind-CSS-Image-Gallery",
  },
  // {
  //   id: 0,
  //   title: "Podstream",
  //   date: "Apr 2023 - May 2023",
  //   description:
  //     "Developed a full-stack web application that allows users to search for, play, and pause their favorite podcasts on demand and create podcasts. Implemented user authentication using Google Auth and Jwt Auth, made responsive user interface with React JS that provides users with a seamless experience across all devices. Practiced agile methodologies to optimize team efficiency and communication.",
  //   image:
  //     "https://user-images.githubusercontent.com/64485885/234602896-a1bd8bcc-b72b-4821-83d6-8ad885bf435e.png",
  //   tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Podstream",
  //   webapp: "https://podstream.netlify.app/",
  //   member: [
  //     {
  //       name: "Rishav Chanda",
  //       img: "https://avatars.githubusercontent.com/u/64485885?v=4",
  //       linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
  //       github: "https://github.com/rishavchanda/",
  //     },
  //     {
  //       name: "Upasana Chaudhuri",
  //       img: "https://avatars.githubusercontent.com/u/100614635?v=4",
  //       linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
  //       github: "https://github.com/upasana0710",
  //     },
  //   ],
  // },
  {
    id: 1,
    title: "Cine Vista",
    date: "Oct 2022 - Jan 2023",
    description:
      "Developed CineVista, a dynamic movie website with a sleek, intuitive interface. Enhanced user engagement by optimizing performance for load times under 2 seconds and integrating advanced search and filtering options, providing a seamless and interactive movie exploration experience.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/Cinevista%20home%20page.png?alt=media&token=709380d4-e765-46e9-b737-eb05f8113e18",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "NodeMailer",
    ],
    category: "web app",
    github: "https://github.com/SwayamSahu/CineVista",
    webapp: "https://github.com/SwayamSahu/CineVista",
  },
  // {
  //   id: 2,
  //   title: "Brain Tumor Detection",
  //   date: "Jan 2023 - Mar 2023",
  //   description:
  //     "Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
  //   image:
  //     "https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png",
  //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
  //   category: "machine learning",
  //   github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
  //   webapp: "https://brain-tumor.netlify.app/",
  //   member: [
  //     {
  //       name: "Rishav Chanda",
  //       img: "https://avatars.githubusercontent.com/u/64485885?v=4",
  //       linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
  //       github: "https://github.com/rishavchanda/",
  //     },
  //     {
  //       name: "Upasana Chaudhuri",
  //       img: "https://avatars.githubusercontent.com/u/100614635?v=4",
  //       linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
  //       github: "https://github.com/upasana0710",
  //     },
  //   ],
  // },
  {
    id: 3,
    title: "Real Estate Price Prediction",
    date: "Dec 2023 - Feb 2024",
    description:
    "Developed a predictive model and improved forecasting accuracy by 20% using Scikit-learn and Linear Regression. Implemented a Python Flask server to serve HTTP requests and retrieve predictions from the trained model. Created a dynamic website using HTML, CSS, and JavaScript, allowing users to input property features such as square footage and number of bedrooms.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/Real%20estate%20price%20prediction_BHP_website.PNG?alt=media&token=e0580895-ef08-4507-be47-f8aa49370ac0",
    tags: ["Python", "Pandas", "Matplotlib", "Sklearn", "HTML", "CSS", "JavaScript", "Flask"],
    category: "AI/ML",
    github: "https://github.com/SwayamSahu/Real-Estate-Price-Prediction-Model",
    webapp: "https://github.com/SwayamSahu/Real-Estate-Price-Prediction-Model",
  },
  
  {
    id: 10,
    title: "React Blog Website",
    date: "April 2024",
    description:
      "Created a robust full-stack blog website using React.js, .NET Web API, and SQL database. Implemented advanced features including dynamic data fetching, modal dialogs, form handling with validation, and API integration. Enhanced user experience with effective error handling, state management, routing parameters, and conditional rendering for a seamless and interactive interface.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/homescreen.png?alt=media&token=da81b76f-948a-49b2-873b-9e11f4aafcd6",
    tags: ["React Js", "JavaScript", "Axios", "HTML", "CSS", "Node Js", "Express Js", "SQL Server"],
    category: "web app",
    github: "https://github.com/SwayamSahu/React-Blog-Website",
    webapp: "https://github.com/SwayamSahu/React-Blog-Website",
  },
  {
    id: 4,
    title: "Angular Blog Website",
    date: "May 2024",
    description:
      "Built a robust full-stack blog platform using Angular, .NET Web API, and SQL database. Enabled user subscriptions for real-time updates, organized content into categories, and implemented secure authentication and authorization with JWT tokens. Enhanced security and user management with role-based access control, delivering a powerful and scalable blogging solution.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/Angular%20blog%20website%20landing%20page.png?alt=media&token=d3b95e4f-c11d-4091-be0f-2d1f6daa5b13",
    tags: ["Angular", "TypeScript", "ASP.NET WEB API", "SQL database"],
    category: "web app",
    github: "https://github.com/SwayamSahu/Angular-Blog-Website",
    webapp: "https://github.com/SwayamSahu/Angular-Blog-Website",
  },
  // {
  //   id: 5,
  //   title: "Todo Web App",
  //   date: "Jun 2021",
  //   description:
  //     " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
  //   image:
  //     "https://camo.githubusercontent.com/84ac6ab6f378348ef28d8184062b7e9e3511a1252ae3966eaa49e8e998f732a7/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
  //   tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Todo-Web-App",
  //   webapp: "https://rishav-react-todo.netlify.app/",
  // },
  {
    id: 6,
    title: "Employee Directory Web Application",
    date: "Jun 2021",
    description:
      "Engineered a comprehensive Employee Directory Application utilizing the .NET MVC framework and SQL database, employing C#, HTML, CSS, and JavaScript. Implemented secure user authentication protocols, designed detailed employee profiles, and integrated advanced search and filtering capabilities. Ensured robust data security and privacy through sophisticated role-based access controls, optimizing user management and operational efficiency.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/ASP.NET%20MVC%20project%20Landing%20Page.png?alt=media&token=0d7b20f7-b352-4114-afac-2e504c151fea",
    tags: ["C#", "ASP.NET MVC", "SQL Database", "JavaScript", "HTML", "CSS"],
    category: "web app",
    github: "https://github.com/SwayamSahu/Employee-Directory-Web-Application",
    webapp: "https://breaking-bad-webapp.netlify.app",
  },
  // {
  //   id: 7,
  //   title: "Quiz App",
  //   date: "Dec 2020 - Jan 2021",
  //   description:
  //     "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
  //   image:
  //     "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
  //   tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
  //   category: "android app",
  //   github: "https://github.com/rishavchanda/Quiz-Earn",
  //   webapp: "https://github.com/rishavchanda/Quiz-Earn",
  // },
  {
    id: 8,
    title: "Telecommunication Customer Churn Analysis Project",
    date: "May 2023 - June 2023",
    description:
      "Led a capstone project for Telecommunication Company XYZ, developing a machine learning model for customer churn prediction. Achieved a 92% accuracy rate in identifying at-risk customers, enabling the creation of targeted retention strategies that improved retention rates by 15%. Enhanced business growth and customer loyalty through data-driven, personalized offers.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/Telecommunication_Customer_Churn_img.png?alt=media&token=8771198a-7da6-4d46-a5f2-3376f1e65050",
    tags: ["Python", "Pandas", "NumPy", "Matplotlib", "Seaborn", "Scikit Learn"],
    category: "AI/ML",
    github: "https://github.com/SwayamSahu/Telecommunication-Customer-Churn-Analysis-Project/tree/main",
    webapp: "https://github.com/SwayamSahu/Telecommunication-Customer-Churn-Analysis-Project/tree/main",
  },
  {
    id: 15,
    title: "Cold Mail Generator",
    date: "Sept 2024 - Nov 2024",
    description:
      "A tool that extracts job listings from career pages and generates personalized cold emails with tailored portfolio links using GROQ, LangChain, and Streamlit.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/cold-email-project-genai.png?alt=media&token=7d2e0623-811a-4382-8e51-8a4af8057cc3",
    tags: ["Python", "LangChain", "Streamlit","groq","ChromaDB"],
    category: "AI/ML",
    github: "https://github.com/SwayamSahu/Cold-Email-Generator-GENAI",
    webapp: "https://github.com/SwayamSahu/Cold-Email-Generator-GENAI",
  },
  {
    id: 9,
    title: "Interactive Form",
    date: "July 2024",
    description:
      "Developed a dynamic and user-friendly interactive form with real-time validation and responsive design. The form featured conditional logic to display or hide fields based on user inputs, enhancing the user experience. Implemented using JavaScript, HTML, CSS.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-728e6.appspot.com/o/interactive%20form.png?alt=media&token=9e21d2ce-564b-41bf-80d3-9ca7032654bc",
    tags: ["HTML", "CSS", "JavaScript"],
    category: "web app",
    github: "https://github.com/SwayamSahu/Interactive-form/tree/main",
    webapp: "https://github.com/SwayamSahu/Interactive-form/tree/main",
  },
];

